import { render, staticRenderFns } from "./CCardTable.vue?vue&type=template&id=1ffdfe2b&scoped=true"
import script from "./CCardTable.vue?vue&type=script&lang=js"
export * from "./CCardTable.vue?vue&type=script&lang=js"
import style0 from "./CCardTable.vue?vue&type=style&index=0&id=1ffdfe2b&scoped=true&lang=css"
import style1 from "./CCardTable.vue?vue&type=style&index=1&id=1ffdfe2b&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffdfe2b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ffdfe2b')) {
      api.createRecord('1ffdfe2b', component.options)
    } else {
      api.reload('1ffdfe2b', component.options)
    }
    module.hot.accept("./CCardTable.vue?vue&type=template&id=1ffdfe2b&scoped=true", function () {
      api.rerender('1ffdfe2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CCardTable.vue"
export default component.exports